import React, { useMemo } from 'react'
import { getFormattedDate } from '../../helpers/timeHelper'
import { toCssColor } from '../../utils/colorUtils'

type Props = {
  qrTag: IQrTag
  onClick: () => void
  eventTypeColors?: Map<string, string | null>
}

const getLatestEvent = (qrTag: IQrTag): IQrTagEvent | null => (
  qrTag.latest_qr_tag_event ?? qrTag.last_event ?? null
)

const formatLatestEvent = (event: IQrTagEvent | null | undefined) => {
  if (!event) return 'イベントなし'

  const summary = [
    event.event_type,
    event.memo ?? event.notes ?? '',
  ].filter((value) => value && value.length > 0).join(' / ')

  return summary || 'イベントなし'
}

const formatLatestEventTime = (event: IQrTagEvent | null | undefined) => {
  if (!event?.occurred_at) return '-'
  return getFormattedDate(event.occurred_at)
}

const QrTagsListItem = ({
  qrTag,
  onClick,
  eventTypeColors,
}: Props) => {
  const latestEvent = useMemo(() => getLatestEvent(qrTag), [qrTag])
  const latestEventText = useMemo(() => formatLatestEvent(latestEvent), [latestEvent])
  const latestEventTime = useMemo(() => formatLatestEventTime(latestEvent), [latestEvent])
  const eventColor = useMemo(() => {
    if (!latestEvent?.event_type) return null
    return latestEvent.event_type_color ?? eventTypeColors?.get(latestEvent.event_type) ?? null
  }, [eventTypeColors, latestEvent])
  const eventColorStyle = useMemo(() => toCssColor(eventColor), [eventColor])
  const description = qrTag.description || '-'
  const qrCodeNumber = qrTag.qr_code_info?.digit_code || '-'

  return (
    <>
      <tr
        className="item list-row"
        onClick={onClick}
        data-testid={`qr-tag-row-${qrTag.id}`}
      >
        <td>{qrTag.name}</td>
        <td>{description}</td>
        <td>{qrCodeNumber}</td>
        <td>
          <div className="qr-tag-event-cell">
            {eventColorStyle && (
              <span
                className="qr-tag-event-color"
                style={{ backgroundColor: eventColorStyle }}
                aria-hidden="true"
              />
            )}
            <span>{latestEventText}</span>
          </div>
        </td>
        <td>{latestEventTime}</td>
      </tr>
      <tr className="divider"><td colSpan={5}><div className="line" /></td></tr>
    </>
  )
}

export default QrTagsListItem
